import * as actionTypes from './actionTypes';

const initialState = {
  activeContactId: null,
  ids: [],
  isLoading: false,
  membersBySpaceId: {},
  myContactId: null,
  editingUserContactId: null,
  editingUserContactIsLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_ALL:
    case actionTypes.FETCH_ALL_BY_SPACE_ID:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_ALL_SUCCESS:
      return {
        ...state,
        ids: action.ids,
        isLoading: false,
      };
    case actionTypes.FETCH_ALL_BY_SPACE_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        membersBySpaceId: {
          ...state.membersBySpaceId,
          [action.spaceId]: action.ids,
        },
      };
    case actionTypes.FETCH_ME_SUCCESS:
      return {
        ...state,
        myContactId: action.id,
      };
    case actionTypes.SET_ACTIVE_CONTACT_ID:
      return {
        ...state,
        activeContactId: action.id,
      };
    case actionTypes.CREATE_SUCCESS:
      return {
        ...state,
        ids: [
          ...state.ids,
          // only add user to list if it is published
          ...(action.contact.isPublished ? [action.contact.id] : []),
        ],
      };
    case actionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        ids: action.contact.isPublished
          ? state.ids
          : state.ids.filter((id) => id !== action.contact.id),
      };
    case actionTypes.DELETE_SUCCESS:
      return {
        ...state,
        ids: state.ids.filter((id) => id !== action.id),
        activeContactId: action.id === state.activeContactId ? null : state.activeContactId,
      };
    case actionTypes.FETCH_BY_USER_ID:
      return {
        ...state,
        editingUserContactIsLoading: true,
      };
    case actionTypes.FETCH_BY_USER_ID_SUCCESS:
      return {
        ...state,
        editingUserContactId: action.id,
        editingUserContactIsLoading: false,
      };
    default:
      return state;
  }
};
